import DataTable, {
	type Cell,
	type TableData,
} from '@vuejs/components/shared/DataTable'
import { CONTENT_PACKAGE, type ContentPackage } from '@vuejs/services/packages/interfaces'
import { usePackagesAndProgramsStore } from '@vuejs/stores/PackagesAndProgramsStore'
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'ListViewPackage',

	emits: { action: (_action: string, _id?: number | string) => true },

	data(): Data {
		return {
			packages: {
				columns: [
					{
						ariaLabel: 'Sort by Name',
						columnId: 'name',
						isSortable: true,
						name: 'Name',
						width: '30%',
					},
					{
						ariaLabel: 'Cumulative Courses',
						columnId: 'cumulative_courses',
						name: 'Cumulative Courses',
					},
					{
						ariaLabel: 'Sub Package',
						columnId: 'sub_package',
						name: 'Sub Package',
						width: '30%',
					},
					{
						ariaLabel: 'Certifications',
						columnId: 'certifications',
						name: 'Certifications',
					},
					{
						ariaLabel: 'Assigned Courses',
						columnId: 'assigned_courses',
						name: 'Assigned Courses',
					},
					{
						ariaLabel: 'Hours',
						columnId: 'hours',
						name: 'Hours',
					},
					{
						ariaLabel: 'Building Blocks',
						columnId: 'building_blocks',
						name: 'Building Blocks?',
					},
					{
						ariaLabel: 'Content Package Actions',
						columnId: 'content_package_actions',
						name: '',
						width: '125px',
					},
				],

				rows: [],
			},
		}
	},

	computed: {
		contentPackages(): TableData {
			return {
				columns: this.packages.columns,
				rows: this.packagesAndProgramsStore.contentPackages.map((p: ContentPackage) => ({
					actions: [
						{
							dataTest: 'package-action-edit',
							icon: 'SVGEdit',
							id: p.id,
							link: p.editPath,
							text: 'Edit',
							tooltip: '',
							type: CONTENT_PACKAGE,
						},
						{
							dataTest: 'package-action-copy',
							icon: 'SVGCopy',
							id: p.id,
							link: p.copyPath,
							text: 'Copy',
							tooltip: '',
							type: CONTENT_PACKAGE,
						},
					],
					cells: this.packageToCellDataArray(p),
					rowId: `${p.id}`,
				})),
			}
		},

		packagesAndProgramsStore() {
			return usePackagesAndProgramsStore()
		},
	},

	methods: {
		packageToCellDataArray(p: ContentPackage): Cell[] {
			return [
				{ title: { text: p.name } },
				{
					badge: {
						style: 'filled',
						text: `${p.cumulativeCourses}`,
						type: 'gray',
					},
					title: { text: '' },
				},
				{ title: { text: p.subPackages } },
				{
					badge: {
						style: 'filled',
						text: `${p.certifications}`,
						type: 'gray',
					},
					title: { text: '' },
				},
				{
					badge: {
						style: 'filled',
						text: `${p.assignedCourses}`,
						type: 'gray',
					},
					title: { text: '' },
				},
				{
					badge: {
						appearance: 'date',
						style: 'filled',
						text: `${p.hours ?? '0 hours'}`,
						type: 'gray',
					},
					title: { text: '' },
				},
				{
					badge: {
						style: 'filled',
						text: `${!!p.isBuildingBlock ? 'Yes' : 'No'}`,
						type: `${!p.isBuildingBlock ? 'danger' : 'success'}`,
					},
					title: { text: '' },
				},
			]
		},
	},

	render() {
		return (
			<div class="packages packages__list_view">
				<div class="packages__container">
					<div class="packages__data-table">
						<DataTable
							data={this.contentPackages}
							dataTest="data-table-content-packages"
							isStickyHeader={true}
							itemsPerPage={20}
							message="No content packages"
							showCheckboxes={false}
							showPagination={true}
							sortable={true}
							onAction={(action: string, id?: number | string): void => this.$emit('action', action, id)}
						/>
					</div>
				</div>
			</div>
		)
	},
})

interface Data {
	packages: TableData
}
